// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e5d099d110e1a6ed63b1","293":"d1c2674bbc4f2f7658f8","518":"9454b748ea7531dfb97c","779":"c78490eab4296937453c"}[chunkId] + ".js";
};